import { acceptHMRUpdate, defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

export const useLabStore = defineStore('lab', () => {
    const all = ref({ data: [] });

    const active = ref({});

    const reset = () => {
        all.value = { data: [] };
    };

    const search = (params) => {
        return axios.get('/api/v1/labs', { params });
    };

    const store = (params) => {
        return axios.post('/api/v1/labs', params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    };

    const update = (params) => {
        return axios.post('/api/v1/labs/' + params.get('hash'), params, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    };

    const destroy = (params) => {
        return axios.delete('/api/v1/labs/' + params.hash);
    };

    const updatePricing = (payload) => {
        return axios.post('/api/v1/labs/' + payload.hash + '/pricing', payload);
    };

    const accessLab = (payload) => {
        return axios.get('/api/v1/labs/' + payload.hash + '/access');
    };

    const stopAccessLab = () => {
        return axios.get('/api/v1/labs/stop-access');
    };

    return {
        active,
        all,
        reset,
        search,
        store,
        update,
        destroy,
        updatePricing,
        accessLab,
        stopAccessLab,
    };
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useLabStore, import.meta.hot));
}
